// extracted by mini-css-extract-plugin
export default {"Loading":"LoaderLayout_Loading__SH-5G","loading":"LoaderLayout_loading__poXsa"};